/* eslint-disable  prefer-destructuring */

import React from 'react';
import styled from 'styled-components';
import { ColDiv, Container, RowDiv, Span, Text } from 'styles';
import { Input, InputFormik, Textarea, FileInput2, Checkbox } from 'components';
import * as S from 'pages/community/inquiry/InquiryStyle';

export default function InquiryForm({ formik, list, agree, agreeCheck, isPrivate, privateCheck }) {
  const question = list.question;

  return (
    <form id="form-inquiry" onSubmit={formik.handleSubmit}>
      <input type="hidden" name="moduleNo" value="2" />
      <input type="hidden" name="openYn" value="1" />
      <S.GridDiv>
        <ColDiv $gap={8}>
          <Text $type="b6" $mType="b7" $fontWeight={500}>
            {question.regUserName.label} <Span $color="alert">*</Span>
          </Text>
          <InputFormik type="text" placeholder={question.regUserName.placeholder} {...formik.getFieldProps('regUserName')} />
          {formik.touched.regUserName && formik.errors.regUserName ? <div className="error">{formik.errors.regUserName}</div> : null}
        </ColDiv>

        <ColDiv $gap={8}>
          <Text $type="b6" $mType="b7" $fontWeight={500}>
            {question.regUserPhone.label} <Span $color="alert">*</Span>
          </Text>
          <InputFormik type="text" placeholder={question.regUserPhone.placeholder} {...formik.getFieldProps('regUserPhone')} />
          {formik.touched.regUserPhone && formik.errors.regUserPhone ? <div className="error">{formik.errors.regUserPhone}</div> : null}
        </ColDiv>

        <ColDiv $gap={8}>
          <Text $type="b6" $mType="b7" $fontWeight={500}>
            {question.regUserEmail.label} <Span $color="alert">*</Span>
          </Text>
          <InputFormik type="text" placeholder={question.regUserEmail.placeholder} {...formik.getFieldProps('regUserEmail')} />
          {formik.touched.regUserEmail && formik.errors.regUserEmail ? <div className="error">{formik.errors.regUserEmail}</div> : null}
        </ColDiv>

        <ColDiv $gap={8}>
          <Text $type="b6" $mType="b7" $fontWeight={500}>
            {question.title.label} <Span $color="alert">*</Span>
          </Text>
          <InputFormik type="text" placeholder={question.title.placeholder} {...formik.getFieldProps('title')} />
          {formik.touched.title && formik.errors.title ? <div className="error">{formik.errors.title}</div> : null}
        </ColDiv>

        <ColDiv $gap={8}>
          <Text $type="b6" $mType="b7" $fontWeight={500}>
            {question.content.label}
          </Text>

          <Textarea
            placeholder={question.content.placeholder}
            name="content"
            className={`${formik.errors.content ? 'is-invalid' : ''}`}
            value={formik.values.content}
            onChangeFormik={formik.handleChange}
          />

          {formik.errors.content ? <div className="error">{formik.errors.content}</div> : null}
        </ColDiv>

        <ColDiv $gap={8}>
          <Checkbox checked={isPrivate} onChange={privateCheck}>
            {list.privateLabel}
          </Checkbox>
        </ColDiv>

        {isPrivate && (
          <>
            <ColDiv $gap={8}>
              <Text $type="b6" $mType="b7" $fontWeight={500}>
                {question.password.label} <Span $color="alert">*</Span>
              </Text>
              <InputFormik type="password" placeholder={question.password.placeholder} {...formik.getFieldProps('regPassword')} />
              {formik.touched.regPassword && formik.errors.regPassword ? <div className="error">{formik.errors.regPassword}</div> : null}
            </ColDiv>

            <ColDiv $gap={8}>
              <Text $type="b6" $mType="b7" $fontWeight={500}>
                {question.passwordCheck.label} <Span $color="alert">*</Span>
              </Text>
              <InputFormik type="password" placeholder={question.passwordCheck.placeholder} {...formik.getFieldProps('passwordCheck')} />
              {formik.touched.passwordCheck && formik.errors.passwordCheck ? <div className="error">{formik.errors.passwordCheck}</div> : null}
            </ColDiv>
          </>
        )}
      </S.GridDiv>

      <ColDiv $gap={8} $padding="24px 0" $mPadding="16px 0 0">
        <Text $type="b6" $mType="b7" $fontWeight={500}>
          {list.uploadFile}
        </Text>
        <FileInput2
          id="uploadFile"
          name="attachments"
          label={list.uploadInputLabel}
          desc={formik.values.uploadFile ? undefined : list.uploadDesc}
          onChange={(e) => {
            formik.setFieldValue('uploadFile', e.currentTarget.files[0]);
          }}
        />
        {formik.values.uploadFile && (
          <RowDiv $gap={16}>
            <Input
              name="testFile"
              value={formik.values?.uploadFile?.name}
              del
              disabled
              delClick={(e) => {
                const uploadFile = document.getElementById('uploadFile');
                uploadFile.value = '';
                formik.setFieldValue('uploadFile', null);
              }}
            />
          </RowDiv>
        )}
      </ColDiv>
    </form>
  );
}
